import { useAuthMutation, useQueryClient } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { OrganizationApi } from 'api';
import { IOrganization } from 'types';

function useUpdate() {
  const queryClient = useQueryClient();
  return useAuthMutation(
    (data: Partial<IOrganization> & { id: number }) => {
      const { id, ...rest } = data;
      return OrganizationApi.put(id, rest);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: getQueryKeys([KEY]).all });
      },
    },
  );
}

export default useUpdate;
